import { render, staticRenderFns } from "./switchCard.vue?vue&type=template&id=70ba2d83&scoped=true&"
import script from "./switchCard.vue?vue&type=script&lang=js&"
export * from "./switchCard.vue?vue&type=script&lang=js&"
import style0 from "./switchCard.vue?vue&type=style&index=0&id=70ba2d83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ba2d83",
  null
  
)

export default component.exports